import { useMutation } from "@tanstack/react-query";
import axios from "axios";
import { useContext } from "react";
import { AuthContext } from "../useAuth";
import { endpoints, getPath } from "./apiUtils";

export const useRatingCreation = (userId) => {
  const path = getPath({
    endpoint: endpoints.users,
    path: [userId, "ratings"],
  });

  const { getAccessToken } = useContext(AuthContext);

  return useMutation(
    async (data) =>
      axios
        .post(path, data, {
          headers: { Authorization: await getAccessToken() },
        })
        .then((r) => r.data),
    {}
  );
};
